import { ChangeDetectionStrategy, Component, inject, input, InputSignal, output } from '@angular/core';

import { MainTitleComponent } from '@connect-services/client/components/main-title/main-title.component';
import { ActionsEnum } from '@connect-services/client/models/panel.model';
import { MapEditModeService } from '@connect-services/client/services/map-edit-mode.service';
import { MapLayerService } from '@connect-services/client/services/map-layer.service';
import { SourcesService } from '@connect-services/client/services/sources.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, MainTitleComponent, RessourcesModule],
    selector: 'app-source-header',
    templateUrl: './source-header.component.html',
})
export class SourceHeaderComponent {
    public readonly areLayersGrouped: InputSignal<boolean> = input.required<boolean>();
    public readonly disabledSourcesCount: InputSignal<number> = input.required<number>();
    public handleLayersVisibility = output<boolean>();
    public updateLayerGrouped = output<boolean>();

    protected readonly ActionsEnum = ActionsEnum;
    protected readonly ButtonType = ButtonType;
    protected readonly mapEditModeService = inject(MapEditModeService);
    protected readonly mapLayerService = inject(MapLayerService);
    protected readonly sourcesService = inject(SourcesService);
}
